<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_statistics"
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      class="scaling-svg"
    >
      <path
        id="Fill_1"
        data-name="Fill 1"
        d="M7.917,0a.417.417,0,0,1,0,.833H.417A.417.417,0,0,1,.417,0Z"
        transform="translate(0.833 8.333)"
      />
      <path
        id="Fill_2"
        data-name="Fill 2"
        d="M0,.417a.417.417,0,0,1,.833,0v7.5a.417.417,0,0,1-.833,0Z"
        transform="translate(0.833 0.833)"
      />
      <path
        id="Fill_3"
        data-name="Fill 3"
        d="M.417,0A.417.417,0,0,1,.833.417V2.083a.417.417,0,1,1-.833,0V.417A.417.417,0,0,1,.417,0Z"
        transform="translate(2.917 5)"
      />
      <path
        id="Fill_4"
        data-name="Fill 4"
        d="M.417,0A.417.417,0,0,1,.833.417V3.75A.417.417,0,0,1,0,3.75V.417A.417.417,0,0,1,.417,0Z"
        transform="translate(5 3.333)"
      />
      <path
        id="Fill_5"
        data-name="Fill 5"
        d="M.417,0A.417.417,0,0,1,.833.417v5a.417.417,0,0,1-.833,0v-5A.417.417,0,0,1,.417,0Z"
        transform="translate(7.083 1.667)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ReportsIcon extends Vue {}
</script>

<style>
</style>
